import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    Card,
    CardActionArea,
    CardActions,
    CardContent,
    CardMedia,
    Container,
    Typography,
    useMediaQuery,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    CircularProgress,
    Grid,
    Dialog,
    DialogActions,
    DialogTitle,
} from "@mui/material";
import { getAuth } from "firebase/auth";
import { db } from "../../firebase";
import {
    collection,
    getDocs,
    query,
    limit,
    orderBy,
    startAfter,
    where,
} from "firebase/firestore";

import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import InfiniteScroll from "react-infinite-scroller";

import LockIcon from "@mui/icons-material/Lock";

function CharacterList() {
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const [user, setUser] = useState("");

    const [charaData, setCharaData] = useState([]);

    const [hasMore, setHasMore] = useState(true);
    const [lastVisible, setLastVisible] = useState(null);

    const [filterUser, setFilterUser] = useState("all");

    const isSP = useMediaQuery("(max-width:600px)");
    const charaWidth = isSP ? 170 : 350;
    const charaMx = isSP ? 1 : 1.5;
    const deadFont = isSP ? 80 : 170;

    const handleChange = (event) => {
        setFilterUser(event.target.value);
    };

    const [failed, setFailed] = useState(false);

    const handleTransChara = (id, privacy, auther) => {
        if (privacy && auther !== user) {
            setFailed(true);
        } else {
            window.scrollTo(0, 0);
            navigate(`/character/${id}`);
        }
    };

    const handleFailedClose = () => {
        setFailed(false);
    };

    useEffect(() => {
        const unsubscribe = getAuth().onAuthStateChanged(async (userLogin) => {
            if (userLogin) {
                setUser(userLogin.uid);
                await fetchData();
            } else {
                window.scrollTo(0, 0);
                navigate("/login", { replace: true });
            }
        });
        return () => unsubscribe();
    }, []);

    const fetchData = async () => {
        const charaRef = collection(db, "character");

        try {
            const q = query(
                charaRef,
                where("deleted", "==", false),
                orderBy("updateAt", "desc"),
                limit(10)
            );
            const charaSnap = await getDocs(q);

            if (charaSnap.empty) {
                setHasMore(false);
                setLoading(false);
                return;
            }

            const charas = [];
            charaSnap.forEach((doc) => {
                const timestamp = doc.data().updateAt.seconds;
                const date = new Date(timestamp * 1000);
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const day = String(date.getDate()).padStart(2, "0");
                const hours = String(date.getHours()).padStart(2, "0");
                const minutes = String(date.getMinutes()).padStart(2, "0");
                const seconds = String(date.getSeconds()).padStart(2, "0");
                const formattedDate = `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;

                charas.push({
                    img: doc.data().img,
                    id: doc.data().id,
                    name: doc.data().name,
                    furi: doc.data().furi,
                    auther: doc.data().auther,
                    updateAt: formattedDate,
                    private: doc.data().private,
                    dead: doc.data().dead,
                });
            });
            setCharaData(charas);

            setLastVisible(charaSnap.docs[charaSnap.docs.length - 1]);
        } catch (error) {
            console.log("error: ", error);
        }

        setLoading(false);
    };

    const fetchMoreData = async () => {
        const charaRef = collection(db, "character");

        try {
            const q = query(
                charaRef,
                where("deleted", "==", false),
                orderBy("updateAt", "desc"),
                limit(10),
                startAfter(lastVisible)
            );
            const charaSnap = await getDocs(q);

            if (charaSnap.empty) {
                setHasMore(false);
                return;
            }

            const charas = [];
            charaSnap.forEach((doc) => {
                const timestamp = doc.data().updateAt.seconds;
                const date = new Date(timestamp * 1000);
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const day = String(date.getDate()).padStart(2, "0");
                const hours = String(date.getHours()).padStart(2, "0");
                const minutes = String(date.getMinutes()).padStart(2, "0");
                const seconds = String(date.getSeconds()).padStart(2, "0");
                const formattedDate = `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;

                charas.push({
                    img: doc.data().img,
                    id: doc.data().id,
                    name: doc.data().name,
                    auther: doc.data().auther,
                    updateAt: formattedDate,
                    private: doc.data().private,
                    dead: doc.data().dead,
                });
            });
            setCharaData((prevData) => [...prevData, ...charas]);

            setLastVisible(charaSnap.docs[charaSnap.docs.length - 1]);
        } catch (error) {
            console.log("error: ", error);
        }
    };

    if (loading) {
        return (
            <Box
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "80vh",
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    return (
        <div>
            <Helmet>
                <title>Character List - SOG Member Site</title>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>

            <Container
                maxWidth="1280"
                sx={{ display: { xs: { maxWidth: 0 } }, maxWidth: 1280 }}
            >
                <Box
                    sx={{ mt: 10 }}
                    style={{
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <FormControl>
                        <InputLabel>作成者</InputLabel>
                        <Select
                            value={filterUser}
                            label="作成者"
                            sx={{ minWidth: 358, maxWidth: 358 }}
                            onChange={handleChange}
                        >
                            <MenuItem value="all">すべて</MenuItem>
                            <MenuItem value="O73YrYlsmmWigCRGeq9aujj4Oxm1">
                                かいむ
                            </MenuItem>
                            <MenuItem value="1">キラリ</MenuItem>
                            <MenuItem value="2">09</MenuItem>
                            <MenuItem value="3">きくりん</MenuItem>
                            <MenuItem value="4">モロ星人</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

                <InfiniteScroll
                    pageStart={0}
                    loadMore={fetchMoreData}
                    hasMore={hasMore}
                    loader={
                        <Box
                            sx={{ m: 1 }}
                            style={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                            key={0}
                        >
                            <CircularProgress />
                        </Box>
                    }
                >
                    <Grid
                        container
                        sx={{ mt: 2 }}
                        style={{
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        {charaData
                            .filter((item) => {
                                if (
                                    filterUser === "all" ||
                                    item.auther === filterUser
                                ) {
                                    return true;
                                } else {
                                    return false;
                                }
                            })
                            .map((item, i) => (
                                <Grid
                                    item
                                    key={i}
                                    xs={5.46}
                                    sm={3.4092}
                                    sx={{
                                        my: 1,
                                        mx: charaMx,
                                    }}
                                >
                                    <Card sx={{ position: "relative" }}>
                                        <CardActionArea
                                            onClick={() =>
                                                handleTransChara(
                                                    item.id,
                                                    item.private,
                                                    item.auther
                                                )
                                            }
                                        >
                                            <CardMedia
                                                component="img"
                                                height={charaWidth}
                                                image={item.img}
                                                sx={{ objectFit: "contain" }}
                                            />
                                            {item.dead && (
                                                <Box
                                                    sx={{
                                                        position: "absolute",
                                                        top: -100,
                                                        left: 0,
                                                        right: 0,
                                                        bottom: 0,
                                                        display: "flex",
                                                        justifyContent:
                                                            "center",
                                                        alignItems: "center",
                                                        transform:
                                                            "rotate(-45deg)",
                                                        opacity: 0.7,
                                                    }}
                                                >
                                                    <Typography
                                                        color="black"
                                                        fontWeight="bold"
                                                        sx={{
                                                            fontSize: deadFont,
                                                        }}
                                                    >
                                                        死亡
                                                    </Typography>
                                                </Box>
                                            )}
                                            {item.private && (
                                                <Box
                                                    sx={{
                                                        position: "absolute",
                                                        display: "flex",
                                                        justifyContent: "left",
                                                        alignItems:
                                                            "flex-start",
                                                        top: 5,
                                                        left: 5,
                                                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                                                        borderRadius: 1,
                                                    }}
                                                >
                                                    <LockIcon sx={{ fontSize: 30 }} />
                                                </Box>
                                            )}
                                            <CardContent>
                                                <Typography
                                                    variant="h6"
                                                    conponent="div"
                                                >
                                                    {item.name}
                                                </Typography>
                                            </CardContent>
                                            <CardActions
                                                sx={{
                                                    justifyContent: "right",
                                                    display: "flex",
                                                }}
                                            >
                                                <Typography
                                                    variant="caption"
                                                    color="text.secondary"
                                                >
                                                    {item.updateAt}
                                                </Typography>
                                            </CardActions>
                                        </CardActionArea>
                                    </Card>
                                </Grid>
                            ))}
                    </Grid>
                </InfiniteScroll>
            </Container>

            <Dialog open={failed}>
                <DialogTitle
                    sx={{
                        minWidth: 263,
                        justifyContent: "center",
                        display: "flex",
                    }}
                >
                    非公開設定です
                </DialogTitle>
                <DialogActions
                    sx={{ justifyContent: "center", display: "flex", mb: 2 }}
                >
                    <Button
                        variant="contained"
                        sx={{ width: "100px" }}
                        onClick={handleFailedClose}
                    >
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default CharacterList;
